import { Download } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { calculateItemMetrics } from '@/lib/metrics'
import type { MetricsDataItem } from '@/entities/dailyMetric'

function exportToCSV(data: Record<string, unknown>[], filename: string) {
  const headers = Object.keys(data[0] || {})
  const csvContent = [
    headers.join(','),
    ...data.map((row) =>
      headers
        .map((header) => {
          const value = row[header]
          return typeof value === 'string' && value.includes(',') ? `"${value}"` : value
        })
        .join(',')
    ),
  ].join('\n')

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')
  const url = URL.createObjectURL(blob)
  link.setAttribute('href', url)
  link.setAttribute('download', filename)
  link.style.visibility = 'hidden'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

interface ExportCSVButtonProps {
  metricsData: MetricsDataItem[]
}

export function ExportCSVButton({ metricsData }: ExportCSVButtonProps) {
  const handleExportCSV = () => {
    const exportData = metricsData.map((item) => ({
      date: item.date,
      ...calculateItemMetrics(item, { raw: true }),
    }))
    exportToCSV(exportData, `dashboard-metrics-${new Date().toISOString().split('T')[0]}.csv`)
  }

  return (
    <Button variant="outline" size="sm" onClick={handleExportCSV} title="Export to CSV">
      <Download className="h-4 w-4 mr-1.5" />
      CSV
    </Button>
  )
}